import React, { useEffect, useState } from "react";

function VideoWithPoster({ src }) {
  const [poster, setPoster] = useState(null);

  useEffect(() => {
    const video = document.createElement("video");
    video.src = src;
    video.muted = true;
    video.preload = "metadata";

    const onLoadedData = () => {
      video.currentTime = 1;
    };

    const onSeeked = () => {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
      setPoster(canvas.toDataURL("image/jpeg"));
      video.removeEventListener("loadeddata", onLoadedData);
      video.removeEventListener("seeked", onSeeked);
    };

    video.addEventListener("loadeddata", onLoadedData);
    video.addEventListener("seeked", onSeeked);

    return () => {
      video.removeEventListener("loadeddata", onLoadedData);
      video.removeEventListener("seeked", onSeeked);
      video.src = "";
    };
  }, [src]);

  return (
    <video
      controls
      controlsList="nodownload"
      preload="none"
      poster={poster || undefined}
      onContextMenu={(event) => event.preventDefault()}
    >
      <source src={src} type="video/mp4" />
    </video>
  );
}

export default VideoWithPoster;
